<template>
  <section class="container">
    <v-card class="content" max-width="1600px" elevation="0">
      <div class="text-center my-8">
        <h1 class="text-h3 font-weight-bold mb-2 main-title">
          Recordações Encontrada
        </h1>
        <p class="text-h6 text-grey-darken-1">
          Lista das despedidas encontradas.
        </p>
      </div>
      <v-card-text class="d-flex flex-column align-center justify-center">
        <v-container>
          <v-row justify="center">
            <v-col
              v-for="(item, index) in despedidas"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card
                @click="toDespedida(item.id)"
                elevation="3"
                class="memorial-card"
                hover
              >
                <!-- Header do card com gradient -->
                <div
                  class="card-header"
                  :style="{
                    backgroundImage: `url(${require('@/assets/pack-banners/' +
                      item.foto_fundo +
                      '.jpg')})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }"
                >
                  <v-avatar size="100" class="memorial-avatar">
                    <v-img
                      v-if="getFotoPerfilUrl(item.nome_arquivo_foto_perfil)"
                      :src="getFotoPerfilUrl(item.nome_arquivo_foto_perfil)"
                      alt="Foto do perfil"
                    ></v-img>

                    <img
                      v-else
                      :src="
                        require('@/assets/' +
                          item.pessoa_falecida.sexo +
                          '.png')
                      "
                      alt="Foto padrão"
                      width="100"
                      height="100"
                    />
                  </v-avatar>
                </div>

                <v-card-text class="text-center pt-4 pb-0 px-2">
                  <h3 class="text-h6 font-weight-bold mb-2 falecido-nome">
                    {{ item.pessoa_falecida?.nome_social || item.pessoa_falecida?.nome }}
                  </h3>
                  <div class="date-container">
                    <!-- Data de nascimento -->
                    <div class="date-item d-flex align-center">
                      <v-icon size="16" color="#343F53" class="mr-1"
                        >mdi-star</v-icon
                      >
                      <span class="text-body-2 text-grey-darken-1">
                        {{ formatDate(item.pessoa_falecida?.data_nascimento) }}
                      </span>
                    </div>

                    <!-- Separador -->
                    <div class="date-separator mx-2">-</div>

                    <!-- Data de falecimento -->
                    <div class="date-item d-flex align-center">
                      <v-icon size="16" color="#343F53" class="mr-1"
                        >mdi-cross</v-icon
                      >
                      <span class="text-body-2 text-grey-darken-1">
                        {{ formatDate(item.pessoa_falecida?.data_falecimento) }}
                      </span>
                    </div>
                  </div>
                </v-card-text>

                <v-card-actions class="justify-center pb-4">
                  <v-btn
                    color="#343F53"
                    variant="elevated"
                    size="small"
                    prepend-icon="mdi-heart"
                  >
                    Ver memorial
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </section>
  <Footer />
</template>

<script>
import Footer from "../restrito/Footer.vue";
import { http } from "@/services/config";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

export default {
  name: "ListaPostagens",
  components: {
    Footer,
  },
  data() {
    return {
      token: "",
      despedidas: [],
    };
  },
  mounted() {
    this.token = this.$route.params.token;
    this.getDespedidas(this.token);
  },
  methods: {
    formatDate(date) {
      return dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    getDespedidas(token) {
      http
        .get("exibicao/despedida-chave/" + token)
        .then((response) => {
          this.despedidas = response.data;
        })
        .catch((error) => {
          console.error("Erro ao consultar:", error);
        });
    },
    toDespedida(id) {
      this.$router.push(`/despedida/${id}`);
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
}

.container {
  height: 90vh;
}

.content {
  margin-top: 1rem;
  margin-left: auto;
  margin-right: auto;
  min-height: 82vh;
}
.main-title {
  color: #343f53;
  font-weight: 700;
  background-clip: text;
}
/* Cards de memorial */
.memorial-card {
  border-radius: 0px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  overflow: hidden;
  height: 20rem;
}

.falecido-nome {
  height: 4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 5;
  line-height: 1.2;
  -webkit-box-orient: vertical;
}

.date-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.date-item {
  white-space: nowrap;
}

.date-separator {
  color: #6c757d;
}

.memorial-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.memorial-avatar {
  border: 4px solid white;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Cards de homenagem */
.homenagem-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.homenagem-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1) !important;
}

.message-text {
  line-height: 1.6;
  color: #495057;
}

/* Responsividade */
@media (max-width: 960px) {
  .main-title {
    font-size: 2rem !important;
  }

  .search-button span {
    display: none;
  }
}

@media (max-width: 600px) {
  .main-title {
    font-size: 1.8rem !important;
  }

  .section-header {
    padding: 16px 0;
  }

  .search-card {
    border-radius: 8px !important;
  }
}

/* Animações */
.v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-chip {
  transition: all 0.2s ease;
}

.v-btn {
  transition: all 0.2s ease;
}
</style>
